import * as React from "react";
import { useCallback } from "react";
import { styled } from "@mui/material";
import { PatientPanel } from "./patientPanel";
import { ConversationQuestionType, QualifiedFeature } from "fe-common/graphql";
import { Answer } from "../solverHooks/useConversation";
import { PatientFacingQuestion } from "../types/patientConversationAliasing";
import { useTranslate } from "../hooks/useTranslate";
import { usePatientFeatureFlags } from "../hooks/usePatientFeatureFlags";

//region [[ Styles ]]

const PatientBackgroundView = styled("div")({
  width: "100%",
  display: "flex",
  flexFlow: "column",
  paddingTop: "5px",
  "&:not(:last-of-type)": {
    paddingBottom: "5px",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientBackgroundStepProps {
  onAnswer: (qfs: QualifiedFeature[], skipped: boolean, metadata?: any) => void;
  question: PatientFacingQuestion;
  answer?: Answer;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientBackground = ({
  answer,
  onAnswer,
  question,
  ...props
}: PatientBackgroundStepProps) => {
  const { translate } = useTranslate();

  const sendBackgroundAnswer = useCallback(
    (selected: QualifiedFeature[], skipped: boolean) => {
      if (skipped) {
        onAnswer([], true);
      } else {
        // const selectedIds = selected.map((qf) => qf.feature.id);
        // const skipped = question.suggestions
        //   .map((s) => s.suggestion)
        //   .filter((qf) => !selectedIds.includes(qf.feature.id))
        //   .map((qf) => ({ ...qf, skip: true }));

        onAnswer([...selected /*, ...skipped*/], false);
      }
    },
    [onAnswer /*, question*/],
  );

  //TODO: move to server, this should be features
  const qTextPrimary =
    question.questionType === ConversationQuestionType.VolunteerBackgroud
      ? translate("Medical History")
      : translate("Family History");

  const qTextSecondary =
    question.questionType === ConversationQuestionType.VolunteerBackgroud
      ? translate("PANEL_SELECTION_TEXT")
      : translate("FAMILY_HISTORY_SELECTION_TEXT");

  const askBeforePresentingBackgroundQuestions =
    usePatientFeatureFlags("askBeforePresentingBackgroundQuestions") &&
    question.questionType === ConversationQuestionType.VolunteerBackgroud;

  return (
    <PatientBackgroundView className={"patient-background"}>
      <PatientPanel
        qText={[qTextPrimary, qTextSecondary]}
        answer={answer}
        suggestions={[]}
        onDone={sendBackgroundAnswer}
        askBeforePresentingQuestion={askBeforePresentingBackgroundQuestions}
        skipButtonText={"NO_BACKGROUND"}
      />
    </PatientBackgroundView>
  );
};
